/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SideInfo } from './sideInfo';
import { LpPairData } from './lpPairData';

/**
 * Synthetic rate response
 */
export interface SyntheticRateResponse {
  priceScale: number;
  qtyScale: number;
  totalScale: number;
  /**
   * Buy side info
   */
  buyInfo: SideInfo;
  /**
   * Sell side info
   */
  sellInfo: SideInfo;
  /**
   * LP specific pair data
   */
  baseAssetLpData: Array<LpPairData>;
  /**
   * LP specific pair data
   */
  quoteAssetLpData: Array<LpPairData>;
  /**
   * Request ID
   */
  requestId: string;
}
